<app-breadcrumb *ngIf="!disableBreadcrumb" [master]="'Rejestracje'" [parentName]="'Rejestracje'" [name]="'Profile sprzedażowe'"></app-breadcrumb>
<div class="sales-profile-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="sales-profile-list-filters">
    <ng-container *ngIf="!disableFilters">
      <app-dict-insurance-companies
        (selectedInsuranceCompany)="selectedInsuranceCompany = $event"
        [multiple]="false" label="TU" class="sales-profile-list-filter"
        [(ngModel)]="initialFilters.insuranceCompany" name="insuranceCompany"
      ></app-dict-insurance-companies>

      <app-dict
        [multiple]="false" [dictType]="'sales_' + selectedInsuranceCompany?.key"
        [label]="'Nazwa profilu'" class="sales-profile-list-filter"
        matTooltip="Najpierw wybierz TU"
        matTooltipPosition="left"
        [matTooltipDisabled]="!!selectedInsuranceCompany"
        [(ngModel)]="initialFilters.type" name="type"
      ></app-dict>

      <app-dict-ofwcas
        [multiple]="false" label="OFWCA"
        class="sales-profile-list-filter"
        [(ngModel)]="initialFilters.ofwca" name="ofwca"
      ></app-dict-ofwcas>

      <app-dict-registrations
        [multiple]="false" label="Rejestracja"
        class="sales-profile-list-filter"
        [(ngModel)]="initialFilters.registration" name="registration"
      ></app-dict-registrations>

      <app-dict
        [multiple]="false" [dictType]="'sales_profile_status'"
        [label]="'Status'" class="sales-profile-list-filter"
        [(ngModel)]="initialFilters.status" name="status"
      ></app-dict>

      <app-datepicker
        class="sales-profile-list-filter"
        label="Data utworzenia od"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
      ></app-datepicker>

      <app-datepicker
        class="sales-profile-list-filter"
        label="Data utworzenia do"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
      ></app-datepicker>

    </ng-container>
  </form>

<!--  <div class="sales-profile-list-buttons" *ngIf="!disableFilters">-->
<!--    <button (click)="downloadReport()" [disabled]="!(userPermissions | async).registration.read_report"-->
<!--            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>-->
<!--    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>-->
<!--    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>-->
<!--  </div>-->

  <table mat-table [dataSource]="salesProfiles">
    <ng-container matColumnDef="logo">
      <th mat-header-cell *matHeaderCellDef [width]="'150px'"> Logo </th>
      <td mat-cell *matCellDef="let element" style="text-align: center">
        <img *ngIf="element.registration.insuranceCompany.imageLocation" src="/rest/crm/insuranceCompany/{{element.registration.insuranceCompany.id}}/image" alt="Zdjęcie" height="30"/>
      </td>
    </ng-container>

    <ng-container matColumnDef="insuranceCompany">
      <th mat-header-cell *matHeaderCellDef> TU </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/tu/szczegoly', element.registration?.insuranceCompany.id]">{{element.registration?.insuranceCompany.name}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="ofwca">
      <th mat-header-cell *matHeaderCellDef> OFWCA </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.registration.ofwca.uuid]">
          {{element.registration.ofwca.fullName}}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="registration">
      <th mat-header-cell *matHeaderCellDef> Rejestracja </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/rejestracje/szczegoly', element.registration.uuid]">
          {{element.registration.insuranceCompany.name}} {{element.registration.ofwca.fullName}}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef> Nazwa profilu </th>
      <td mat-cell *matCellDef="let element">
        {{element.type.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element" class="status-select">
        <app-dict
          label="" [ngModel]="element.status.id" dictType="sales_profile_status" [required]="true"
          [disabled]="!(userPermissions | async).registration.write || updateInProgress"
          (selectedDict)="statusChanged($event, element)"
        ></app-dict>
      </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data utworzenia </th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="note">
      <th mat-header-cell *matHeaderCellDef> Uwagi</th>
      <td mat-cell *matCellDef="let element">
        <mat-form-field>
          <mat-label>Uwagi</mat-label>
          <textarea
            style="height: 50px"
            [disabled]="!(userPermissions | async).registration.write || updateInProgress"
            (focusout)="noteChanged($event, element)" matInput [value]="element.note"></textarea>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> </th>
      <td mat-cell *matCellDef="let element">
        <button color="warn" mat-icon-button [disabled]="!(userPermissions | async).registration.delete" (click)="delete(element)"><mat-icon>delete</mat-icon></button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
